import useSWR from "swr";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ServicesURL } from "@utils/utilsApi";
import { FilterableField } from "./types";

export const useLOFilterableFields = (
  corporateId: string,
  enabled: boolean = true,
) => {
  const url =
    enabled && corporateId
      ? ServicesURL.getLOFilterableFields.replace(":idCorporate", corporateId)
      : null;

  const { data, isLoading, error } = useSWR(url, (u: string) =>
    fetcher(u, MethodType.GET),
  );

  const fields: FilterableField[] = Array.isArray(data) ? data : [];

  return { fields, isLoading, error };
};
